var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter__list_item_search"},[_c('input',{attrs:{"type":"text"}})])
}]

export { render, staticRenderFns }